import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { Industry } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IAdminUserSessionComponentProps, MastheadPortalId } from '../../../../models/AdminModels';
import { UserSessionViewModelKey } from '../../../../models/AppState';
import { useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { AdminPermission } from '../../../../viewmodels/AdminViewModels';
import { NavigationBreadcrumbsBar } from '../../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../../web/components/Portal';
import {
	GhostCalendarWideCardGraphicAlternative,
	GhostCalendarWideCardGraphicBackground,
} from '../../../../web/components/svgs/graphics/GhostCalendarWideCardGraphic';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { ConditionalAccess } from '../../../components/ConditionalAccess';
import { CampaignTemplatesByIndustry } from '../CampaignTemplatesByIndustry';
import { IndustryTemplates } from '../IndustryTemplates';
import { IndustryTemplatesCreateButton } from '../IndustryTemplates/prensentation';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps, RouteComponentProps<any>, IAdminUserSessionComponentProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

const onRenderCampaignTemplatesByVertical = (industry: Industry, _props: RouteComponentProps<any>) => {
	return <CampaignTemplatesByIndustry {..._props} industry={industry} />;
};
const _CampaignTemplates = ({ className, styles, history }: IProps) => {
	const fullscreenModal = useFullscreenModal();
	const [creatingNewsletterTemplate] = React.useState(false);

	const CREATE_NEW_BUTTONS = [
		{
			label: 'Email Campaign',
			onClick: () => fullscreenModal?.history.push('/campaign-templates/email/edit'),
		},
		{
			label: 'Newsletter',
			onClick: () => fullscreenModal?.history.push('/campaign-templates/html-newsletter/edit'),
		},
		{
			label: 'Social Media Post',
			onClick: () => fullscreenModal?.history.push('/campaign-templates/social/edit'),
		},
		{
			label: 'Blog Post',
			onClick: () => fullscreenModal?.history.push('/campaign-templates/blog-post/edit/new'),
		},
		{
			label: 'Card',
			onClick: () => fullscreenModal?.history.push('/campaign-templates/hwc/create'),
		},
	];

	const onGhostCalendarClick = () => {
		history.push('/campaigns/ghost-calendar');
	};

	return (
		<div className={`${css(...(styles || []))} campaign-templates ${className || ''}`}>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar />
			</Portal>
			<IndustryTemplates onRenderTemplatesByIndustryRoute={onRenderCampaignTemplatesByVertical}>
				<IndustryTemplates.ActionBarHeader>
					<ConditionalAccess permission={AdminPermission.ManageTemplates}>
						<>
							<div className={css(baseStyleSheet.horizontalStack, styleSheet.createButtons)}>
								{CREATE_NEW_BUTTONS.map(card => (
									<IndustryTemplatesCreateButton
										key={`card-${card.label}`}
										disabled={creatingNewsletterTemplate}
										onClick={card.onClick}
									>
										{card.label}
									</IndustryTemplatesCreateButton>
								))}
							</div>
							<button className={css(styleSheet.ghostCalendarButton)} onClick={onGhostCalendarClick}>
								<GhostCalendarWideCardGraphicAlternative />
								<div className={css(styleSheet.background)}>
									<GhostCalendarWideCardGraphicBackground />
								</div>
							</button>
						</>
					</ConditionalAccess>
				</IndustryTemplates.ActionBarHeader>
			</IndustryTemplates>
		</div>
	);
};

const CampaignTemplatesAsObserver = observer(_CampaignTemplates);
const CampaignTemplatesWithContext = inject(UserSessionViewModelKey)(CampaignTemplatesAsObserver);
export const CampaignTemplates = withRouter(withEventLogging(CampaignTemplatesWithContext, 'Campaigns'));
